import { render, staticRenderFns } from "./IrrigationWorks.vue?vue&type=template&id=580537bf&scoped=true&"
import script from "./IrrigationWorks.vue?vue&type=script&lang=js&"
export * from "./IrrigationWorks.vue?vue&type=script&lang=js&"
import style0 from "./IrrigationWorks.vue?vue&type=style&index=0&id=580537bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580537bf",
  null
  
)

export default component.exports